export default {
  // Number of categories in the game
  numberCategories: 5,

  // Number of questions per category
  category1Length: 25,
  category2Length: 30,
  category3Length: 31,
  category4Length: 13,
  category5Length: 30,
  category6Length: 0,

  // Category names
  categoryNames: {
    "category-1": "Pulse",
    "category-2": "Respiration",
    "category-3": "Blood Pressure",
    "category-4": "Body Temperature",
    "category-5": "Temperature",
    "category-6": "",
  },

  //(Online [TRUE] or Local [FALSE])
  online: true,

  // Random [TRUE] or not random [FALSE]
  randomizedQuestions: false,
};
